import {
  FETCH_NEIGHBOURHOODS_DATA_REQUEST,
  FETCH_NEIGHBOURHOODS_DATA_SUCCESS
} from "../constants/actionTypes";
import { createReducer } from "../utils";

const initialState = {
  page: 1,
  neighbourhoods: {},
  count: 0,
  isFetching: true,
  neighbourhood: {}
};

export const neighbourhoodsReducer = createReducer(initialState, {
  [FETCH_NEIGHBOURHOODS_DATA_SUCCESS]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: false
    };
  },
  [FETCH_NEIGHBOURHOODS_DATA_REQUEST]: (state, payload) => {
    return {
      ...state,
      ...payload,
      isFetching: true
    };
  }
});

export default neighbourhoodsReducer;
